import { useMemo } from 'react'

import { TableFilters } from '@circlefin/components'
import { Currency } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import type { SelectListItem } from '@circlefin/components/lib/SelectList'
import type { FilterBaseProps } from '@circlefin/components/lib/TableFilters/types'

export const CurrencyFilter: React.FC<FilterBaseProps> = (props) => {
  const { t } = useTranslation('settings')
  const items: Array<SelectListItem<Currency | undefined>> = useMemo(
    () => [
      { value: undefined, label: t('billing.feeHistory.table.filters.all') },
      {
        value: Currency.USD,
        label: Currency.USDC,
        icon: Currency.USDC,
      },
      {
        value: Currency.EUR,
        label: Currency.EURC,
        icon: Currency.EURC,
      },
    ],
    [t],
  )

  return (
    <TableFilters.Dropdown
      {...props}
      items={items}
      placeholder={t('billing.feeHistory.table.filters.currencyPlaceholder')}
    />
  )
}
